import React from 'react';
import * as WidgetBlocks from '@metservice/mov-report-view-blocks';
import styled from 'styled-components';
import { usePlatStageContext } from '@mono/use-plat-stage';

import ConfiguredReactGridLayout from './ConfiguredReactGridLayout';
import WidgetBlockContainer from './WidgetBlockContainer';
import StaticViewBlockContainer from './StaticViewBlockContainer';
import { ImportedWidgetblockContainer } from './ImportedWidgetblockContainer';

export const checkReportViewblockIsWidget = (reportViewblockType) => {
    return WidgetBlocks[reportViewblockType] ? true : false;
};

const ReportStyledItem = styled.div`
    :hover {
        cursor: pointer;
    }
`;

export default ({ layout, widgetsConfiguration, date, timezone, width, cfjsons, datasets, importedWeatherWidgets, report, ...otherProps }) => {
    const { stage } = usePlatStageContext();
    const pages = report.reportConfiguration.numberOfPages ?? 1;

    return (
        <div className='pdf-renderer' style={{ height: pages * 1550 }}>
            <ConfiguredReactGridLayout width={width} layout={layout} {...otherProps}>
                {widgetsConfiguration.map((widgetConfiguration) => {
                    const isWidgetBlock = checkReportViewblockIsWidget(widgetConfiguration.type);
                    return (
                        <ReportStyledItem key={widgetConfiguration.key || widgetConfiguration.id}>
                            {isWidgetBlock && (
                                <WidgetBlockContainer
                                    viewblockState={widgetConfiguration.viewblockState}
                                    widgetblockType={widgetConfiguration.type}
                                    date={date}
                                    timezone={timezone}
                                    stage={stage}
                                    updateInterval={1000 * 60 * 60}
                                    renderingForPDF={false} // todo: Come back and check on this one
                                    datasets={datasets}
                                    cfjsons={cfjsons}
                                />
                            )}
                            {!isWidgetBlock && (
                                <StaticViewBlockContainer
                                    reportViewBlockType={widgetConfiguration.type}
                                    viewblockState={widgetConfiguration.viewblockState}
                                    date={date}
                                    timezone={timezone}
                                    onEditMarkdown={otherProps.onEditMarkdown ? (content) => otherProps.onEditMarkdown(widgetConfiguration.key, content) : null}
                                />
                            )}
                        </ReportStyledItem>
                    );
                })}
                {report.importedWidgetblocks &&
                    report.importedWidgetblocks.map(({ widgetblockId, layoutId }) => {
                        const importedWeatherWidget = importedWeatherWidgets.find((widget) => widget.id === widgetblockId);
                        return (
                            <div key={layoutId}>
                                <ImportedWidgetblockContainer
                                    date={date}
                                    renderingForPDF={otherProps.renderingForPDF}
                                    cfjsons={cfjsons}
                                    datasets={datasets}
                                    weatherWidget={importedWeatherWidget}
                                    stage={stage}
                                />
                            </div>
                        );
                    })}
            </ConfiguredReactGridLayout>
        </div>
    );
};
